import { render, staticRenderFns } from "./HistoryDeliveriesTable.vue?vue&type=template&id=486dcebc&scoped=true"
import script from "./HistoryDeliveriesTable.vue?vue&type=script&lang=js"
export * from "./HistoryDeliveriesTable.vue?vue&type=script&lang=js"
import style0 from "./HistoryDeliveriesTable.vue?vue&type=style&index=0&id=486dcebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486dcebc",
  null
  
)

export default component.exports